import { TError, TProfession } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../axios';

export const getProfessionsQueryKey = () => ['pro-directory', 'professions'] as const;

export const useGetProfessionsQuery = () =>
  useQuery<TProfession[], TError>({
    queryKey: getProfessionsQueryKey(),
    queryFn: async () => {
      const { data } = await axios.get<TProfession[]>('pro-directory/professions');
      return data;
    },
    staleTime: 1000 * 60 * 60, // 1h — static data
  });
